import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  return <footer className="bg-brand-dark text-brand-cream/60 py-12 px-4 border-t border-brand-gold/20 relative z-40" data-id="element-55">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-56">
        <p className="text-2xl font-heading text-brand-gold font-bold" data-id="element-57">
          Snack Sin Antojo
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base" data-id="element-58">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-lightGold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-gold/50 rounded px-2 py-1" data-id="element-59">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-brand-lightGold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-gold/50 rounded px-2 py-1" data-id="element-60">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs md:text-sm text-brand-cream/40 pt-4" data-id="element-61">
          &copy; {new Date().getFullYear()} Snack Sin Antojo. Todos los derechos
          reservados.
        </p>
      </div>

      <AnimatePresence data-id="element-62">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-63">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-brand-dark/80 backdrop-blur-sm" data-id="element-64" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl max-h-[85vh] bg-brand-cream rounded-2xl shadow-2xl overflow-hidden flex flex-col" data-id="element-65">
              <div className="flex items-center justify-between p-6 border-b border-brand-gold/20 bg-brand-cream sticky top-0 z-10" data-id="element-66">
                <h2 className="text-2xl font-heading font-bold text-brand-dark" data-id="element-67">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 text-brand-dark/60 hover:text-brand-dark hover:bg-brand-gold/10 rounded-full transition-colors focus:outline-none" aria-label="Cerrar modal" data-id="element-68">
                  <X className="w-6 h-6" data-id="element-69" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto text-brand-darkText/80 space-y-6 text-sm md:text-base" data-id="element-70">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-71">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES')}
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-72">
                      1. Información que recopilamos
                    </h3>
                    <p data-id="element-73">
                      Recopilamos la información que nos proporcionas
                      directamente cuando realizas una compra, te suscribes a
                      nuestro boletín o te comunicas con nosotros. Esto puede
                      incluir tu nombre, dirección de correo electrónico y
                      detalles de pago procesados de forma segura a través de
                      nuestros proveedores de pago.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-74">
                      2. Uso de la información
                    </h3>
                    <p data-id="element-75">
                      Utilizamos la información que recopilamos para procesar
                      tus transacciones, enviarte los productos digitales
                      adquiridos, responder a tus consultas y, si has optado por
                      ello, enviarte correos electrónicos promocionales sobre
                      nuevos productos o actualizaciones.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-76">
                      3. Protección de datos
                    </h3>
                    <p data-id="element-77">
                      Implementamos medidas de seguridad razonables para
                      proteger tu información personal contra acceso no
                      autorizado, alteración, divulgación o destrucción. No
                      vendemos, comercializamos ni transferimos a terceros tu
                      información personal identificable.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-78">
                      4. Cookies
                    </h3>
                    <p data-id="element-79">
                      Utilizamos cookies para mejorar tu experiencia en nuestro
                      sitio web, analizar el tráfico y personalizar el
                      contenido. Puedes elegir desactivar las cookies a través
                      de la configuración de tu navegador.
                    </p>
                  </> : <>
                    <p data-id="element-80">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES')}
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-81">
                      1. Aceptación de los términos
                    </h3>
                    <p data-id="element-82">
                      Al acceder y utilizar este sitio web, aceptas estar sujeto
                      a estos Términos y Condiciones. Si no estás de acuerdo con
                      alguna parte de estos términos, no podrás acceder al
                      servicio ni comprar nuestros productos.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-83">
                      2. Propiedad Intelectual
                    </h3>
                    <p data-id="element-84">
                      Todo el contenido incluido en este sitio, como textos,
                      gráficos, logotipos, imágenes, recetas y descargas
                      digitales, es propiedad de Snack Sin Antojo y está
                      protegido por las leyes de derechos de autor
                      internacionales. La compra de nuestros productos digitales
                      te otorga una licencia personal, no exclusiva y no
                      transferible para usar el contenido.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-85">
                      3. Productos Digitales
                    </h3>
                    <p data-id="element-86">
                      Debido a la naturaleza de los productos digitales
                      (descargas instantáneas), todas las ventas son finales. No
                      se emitirán reembolsos una vez que el producto haya sido
                      descargado, a menos que se especifique explícitamente una
                      garantía de devolución de dinero en la página de ventas.
                    </p>

                    <h3 className="text-lg font-bold text-brand-dark mt-6 mb-2" data-id="element-87">
                      4. Descargo de Responsabilidad Médica
                    </h3>
                    <p data-id="element-88">
                      La información y las recetas proporcionadas en nuestros
                      productos tienen fines educativos e informativos
                      únicamente. No pretenden sustituir el consejo médico
                      profesional, el diagnóstico o el tratamiento. Siempre
                      busca el consejo de tu médico u otro proveedor de salud
                      calificado con cualquier pregunta que puedas tener sobre
                      una condición médica o dieta.
                    </p>
                  </>}
              </div>

              <div className="p-6 border-t border-brand-gold/20 bg-brand-cream/50 text-center" data-id="element-89">
                <button onClick={() => setActiveModal(null)} className="bg-brand-dark text-brand-cream px-8 py-3 rounded-full font-medium hover:bg-brand-medium transition-colors" data-id="element-90">
                  Entendido
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </footer>;
}